import React from 'react';

import {
  Link as RouterLink,
  useLocation,
} from 'react-router-dom';
import {
  ThemeProvider,
} from 'styled-components';

import { theme } from '@waglabs/base-theme';
import { Typography } from '@waglabs/typography';

import { WagRedirect } from '../../components/WagRedirect';
import {
  ROUTE_SIGNUP_COMPLETE,
  ROUTE_HOME,
  ROUTE_APP,
  Routes,
} from '../../constants';
import {
  useGetAuth,
} from '../../hooks';
import { useGetWalkerFromUrlQuery } from '../../hooks/useGetWalkerFromUrlQuery';
import { useIsInEmbed } from '../../hooks/useIsInEmbed';

import { SignUpContainer } from './components/SignUpContainer';
import { SignUpHeader } from './components/SignUpHeader';

// Unhandled paths will do its own navigation. What is the alternative approach?
const isPathRedirectUnhandled = (
  path: string, // Add a bang operator to turn it around
) => ![
  Routes.SignupPetInfoPart1,
  Routes.SignupPetInfoPart2,
  Routes.SignupAddress,
  Routes.SignupComplete,
].includes(path);

export const WagSignUpV2 = () => {
  const {
    pathname,
  } = useLocation();
  const { isLoggedIn } = useGetAuth();

  const isInEmbed = useIsInEmbed();
  const walker = useGetWalkerFromUrlQuery();

  if (isInEmbed && !walker.isValid) {
    /**
     * If the walker is not valid, redirect them to the root instead
     * We cannot redirect it to the signup as it will cause infinite loop
     * We also have to use the native way of redirecting to "get out" of the embedded app
     */
    window.location.href = ROUTE_APP;
    return null;
  }

  // TODO: After launch, figure out how to not redirect the user to the Home page
  // when they log in at /signup/basic-info via Social
  // if (isLoggedIn && isPathRedirectUnhandled(pathname)) {
  //   return (
  //     <WagRedirect
  //       to={{
  //         path: ROUTE_HOME,
  //       }}
  //     />
  //   );
  // }

  return (
    <ThemeProvider theme={theme}>
      <>
        {/* Don't render the Signup Header when user is signing up through wagweb Walker Profile modal */}
        {!isInEmbed && (
          <SignUpHeader>
            {pathname === ROUTE_SIGNUP_COMPLETE ? (
              <RouterLink to={ROUTE_HOME}>
                <Typography color="wagGreen" hover variant="body2">
                  Home
                </Typography>
              </RouterLink>
            ) : null}
          </SignUpHeader>
        )}

        <SignUpContainer />
      </>
    </ThemeProvider>
  );
};

export default WagSignUpV2;
